import { cva } from '@/styled-system/css';

export const comboboxOptionMetaRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'meta',
    color: { base: 'text.subtle' },
    textStyle: 'body',
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'text.subtle',
          _groupActive: 'text.subtle',
        },
      },
    },
    selected: {
      true: {
        color: { base: 'text.subtle' },
      },
      false: {},
    },
  },
});
